import axios from 'axios';

const dataValidationAPI = {
  /**
   * Get validation rules for specified tables and connector names
   */
  getValidationRules: async (tables: string[], connectorNames: string[]) => {
    const response = await axios.post(
      '/api/v1/connector/dataValidation/rules',
      {
        tables,
        connectorNames,
      }
    );
    return response.data;
  },

  /**
   * Get details for a specific validation rule
   */
  getValidationRuleDetails: async (
    ruleId: number,
    tableId: number,
    datastoreId?: number
  ) => {
    const params: Record<string, string | number> = {
      table_id: tableId,
    };

    if (datastoreId !== undefined) {
      params.datastore_id = datastoreId;
    }

    const response = await axios.get(
      `/api/v1/connector/dataValidation/rules/${ruleId}`,
      {
        params,
      }
    );
    return response.data;
  },

  /**
   * Run a scheduled scan
   */
  runScheduledScan: async () => {
    const response = await axios.post('/api/v1/connector/dataValidation/scan');
    return response.data;
  },

  /**
   * Get scan status
   */
  getScanStatus: async (scheduleId: number) => {
    const response = await axios.get(
      '/api/v1/connector/dataValidation/scan/status',
      {
        params: { schedule_id: scheduleId },
      }
    );
    return response.data;
  },
};

export default dataValidationAPI;
